import React, {Component} from 'react'
import {Button} from 'antd';
import {Link} from 'react-router';

class SystemButtonHub extends Component {
  handleClick(system) {
    this.props.onSetSystem(system)
  }

  render() {
    const {system} = this.props
    const to = `/systems/${system.ID}/hubs`
    return <Link to={to} onClick={() => this.handleClick(system)}>
      <Button type="primary" ghost="ghost" size="small">
        Hub
      </Button>
    </Link>
  }
}

export default SystemButtonHub;



// WEBPACK FOOTER //
// ./src/components/SystemButtonHub.js